/**
 * Cart Drawer Button Fix
 * This script fixes the View Cart and Checkout buttons in the cart drawer
 * and ensures there are no invisible overlays blocking interaction
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Drawer Button Fix initialized');

  // Function to fix cart drawer buttons
  function fixCartDrawerButtons() {
    console.log('Fixing cart drawer buttons');

    // Get the cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found - cannot fix buttons');
      return;
    }

    // Fix the overlay to ensure it doesn't block buttons
    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      console.log('Found cart drawer overlay, ensuring it doesn\'t block buttons');
      // Make sure the overlay doesn't block interaction with buttons
      overlay.style.pointerEvents = 'none';

      // Re-enable pointer events only for the overlay itself
      // This allows the overlay to be clicked to close the drawer
      overlay.addEventListener('click', function(event) {
        // Only close if the click was directly on the overlay
        if (event.target === overlay) {
          console.log('Overlay clicked, closing drawer');
          if (typeof cartDrawer.close === 'function') {
            cartDrawer.close();
          }
        }
      });
    }

    // Fix the View Cart button
    const viewCartButton = cartDrawer.querySelector('#CartDrawer-ViewCart');
    if (viewCartButton) {
      console.log('Found View Cart button, fixing it');

      // Remove any existing event listeners
      const newViewCartButton = viewCartButton.cloneNode(true);
      viewCartButton.parentNode.replaceChild(newViewCartButton, viewCartButton);

      // Add a proper event listener
      newViewCartButton.addEventListener('click', function(event) {
        console.log('View Cart button clicked');
        // Allow the default navigation to cart page
        // Just close the drawer before navigating
        if (typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        }
      });

      // Ensure the button is clickable
      newViewCartButton.style.position = 'relative';
      newViewCartButton.style.zIndex = '1000000';
      newViewCartButton.style.pointerEvents = 'auto';
    } else {
      console.warn('View Cart button not found');
    }

    // Fix the Checkout button
    const checkoutButton = cartDrawer.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) {
      console.log('Found Checkout button, fixing it');

      // Remove any existing event listeners
      const newCheckoutButton = checkoutButton.cloneNode(true);
      checkoutButton.parentNode.replaceChild(newCheckoutButton, checkoutButton);

      // Add a direct checkout link instead of form submission
      newCheckoutButton.addEventListener('click', function(event) {
        console.log('Checkout button clicked');
        event.preventDefault();
        event.stopPropagation();

        // Redirect directly to checkout
        window.location.href = '/checkout';
      });

      // Ensure the button is clickable
      newCheckoutButton.style.position = 'relative';
      newCheckoutButton.style.zIndex = '1000000';
      newCheckoutButton.style.pointerEvents = 'auto';
    } else {
      console.warn('Checkout button not found');
    }

    // Make sure the cart__ctas container is also clickable
    const ctasContainer = cartDrawer.querySelector('.cart__ctas');
    if (ctasContainer) {
      ctasContainer.style.position = 'relative';
      ctasContainer.style.zIndex = '1000000';
      ctasContainer.style.pointerEvents = 'auto';
    }
  }

  // Fix buttons when cart drawer is opened
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a cart button
    if (event.target.closest('[data-cart-drawer-trigger], .js-drawer-open-cart, #cart-icon-bubble, #mobile-cart-icon-bubble')) {
      // Wait for the cart drawer to open
      setTimeout(fixCartDrawerButtons, 500);
    }
  });

  // Also fix buttons on page load in case cart drawer is already open
  setTimeout(fixCartDrawerButtons, 1000);

  // Add a mutation observer to detect when the cart drawer becomes active
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            console.log('Cart drawer became active, fixing buttons');
            setTimeout(fixCartDrawerButtons, 300);
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }
});
